module.exports = __webpack_public_path__ + "static/media/DOUBLE WELT.a92635e2.svg";